import { useCallback, useMemo, useState } from "react"

import { cn } from "@productlane/lib/src/browser"
import { Button, Empty, LinearIconThemed } from "@productlane/ui"

import RoadmapImage from "@/assets/empty-states/empty-roadmap.png"
import { env } from "@/env"

interface Props {
	title: string
	description: string
	className?: string
	variant: "portal"
}

export function ConnectLinear({
	title,
	description,
	className,
	variant,
}: Props) {
	const [isLoading, setIsLoading] = useState(false)
	const image = useMemo(() => {
		if (variant === "portal") {
			return RoadmapImage
		}
	}, [variant])

	const handleConnect = useCallback(() => {
		setIsLoading(true)
		window.location.href = `${env.VITE_API_URL}/api/auth/linear?action=connect&prompt=consent&redirectUrl=${env.VITE_BASE_URL}/settings/integrations/linear`
	}, [])

	const handleHowItWorks = useCallback(() => {
		// @ts-expect-error Global widget calls
		// eslint-disable-next-line
		window.Productlane?.openDocs("bb5ca077-16c1-4d97-811e-c3107d2f1e87")
	}, [])

	return (
		<div
			className={cn(
				"relative flex min-h-0 w-full flex-1 items-center justify-center px-3 pt-8 sm:pt-0",
				className,
			)}
		>
			<Empty
				title={title}
				text={description}
				className="max-w-[32rem]"
				variant="left"
				image={
					<img
						src={image}
						alt="Roadmap"
						className="h-auto w-[4.5rem] object-contain"
					/>
				}
				action={
					<div className="flex items-center gap-4">
						<Button
							onClick={handleConnect}
							isLoading={isLoading}
							Icon={LinearIconThemed}
						>
							Connect Linear
						</Button>
						<Button variant="outline" onClick={handleHowItWorks}>
							How it works
						</Button>
					</div>
				}
			/>
		</div>
	)
}
